// ABOUTME: Signals the end of a configurator session: the drawer is closed and no save started from it is running.
// ABOUTME: Lets a host stay mounted (and show its saving backdrop) until the save that follows a close completes.

import { useEffect, useRef } from 'react';

interface UseConfiguratorSessionEndInput {
    /** True while the configurator drawer is open. */
    open: boolean;
    /** True while a finalized configuration is being saved. */
    saving: boolean;
    /** Called once on each active → idle transition, never on the first render. */
    onEnd: () => void;
}

export function useConfiguratorSessionEnd({ open, saving, onEnd }: UseConfiguratorSessionEndInput) {
    const wasActiveRef = useRef(false);
    const active = open || saving;
    useEffect(() => {
        if (active) {
            wasActiveRef.current = true;
            return;
        }
        if (wasActiveRef.current) {
            wasActiveRef.current = false;
            onEnd();
        }
    }, [active, onEnd]);
}
